import { Pipe } from '@angular/core';
import { ColOrColGroupDef } from '@bo-client/shared/entity-list-page/entity-list-page.types';
import { ColGroupDef } from 'ag-grid-community';

/**
 * Pipe zum Verstecken von Spalten, die nicht im Excel-Export von Listen angezeigt werden sollen
 *
 * Entfernt ColDefs aus Array, die ```hideColumnInExport = true``` als Attribut haben
 */
@Pipe({
  name: 'entityListPageExport'
})
export class EntityListPageExportPipe {
  transform = (colDefs: ColOrColGroupDef[]): ColOrColGroupDef[] => {
    const filteredDefs = colDefs.filter((colDef) => !colDef.hideColumnInExport);
    for (const colDef of filteredDefs) {
      if (!!(colDef as ColGroupDef).children?.length) {
        (colDef as ColGroupDef).children = this.transform((colDef as ColGroupDef).children);
      }
    }
    return filteredDefs;
  };
}
